import "./Spinner.css"

export enum SpinnerSize {
    SIZE_128 = "s-128",
    SIZE_48 = "s-48",
    SIZE_24 = "s-24",
    SIZE_16 = "s-16",
    SIZE_10 = "s-10",
}

interface Props {
    size: SpinnerSize
}

function Spinner({size}: Props) {
    return <span className={"spinner " + size}></span>
}

export default Spinner;
